module.exports = __webpack_public_path__ + "img/step3.642b4fd2.jpeg";